module.exports = __webpack_public_path__ + "static/media/01B.cf36b628.png";